const FetchStatus = {
  IDLE: '',
  FETCHING: 'FETCHING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

export default FetchStatus;
